// 导入axios
import axios from 'axios'

// 设置基础路径
// axios.defaults.baseURL = "https://jiusan.htseasky.com:9001/prod-api"
axios.defaults.baseURL = "http://www.shx93.gov.cn/prod-api"
// axios.defaults.baseURL = "http://192.168.124.3:9002"

// 设置超时
// axios.defaults.timeout = 5000

// 设置请求拦截器
axios.interceptors.request.use(config => {
    return config
}, err => {
    return Promise.reject(err)
})
// 设置响应拦截器
axios.interceptors.response.use(response => {
    return response
}, err => {
    return Promise.reject(err)
})
export default axios